import { css } from 'styled-components'

export const Roboto_num1_b24 = css`
  font-size: 24px;
  line-height: 24px;
  font-weight: 700;
  font-family: RobotoBold, sans-serif;
`
export const Roboto_num1_b22 = css`
  font-size: 22px;
  line-height: 24px;
  font-weight: 700;
  font-family: RobotoBold, sans-serif;
`
export const Roboto_num1_b20 = css`
  font-size: 20px;
  line-height: 24px;
  font-weight: 700;
  font-family: RobotoBold, sans-serif;
`
export const Roboto_num1_b18 = css`
  font-size: 18px;
  line-height: 24px;
  font-weight: 700;
  font-family: RobotoBold, sans-serif;
`

export const Roboto_num1_r18 = css`
  font-size: 18px;
  line-height: 24px;
  font-weight: 400;
  font-family: RobotoRegular, sans-serif;
`
export const Roboto_num2_b16 = css`
  font-size: 16px;
  line-height: 20px;
  font-weight: 700;
  font-family: RobotoBold, sans-serif;
`

export const Roboto_num2_r16 = css`
  font-size: 16px;
  line-height: 20px;
  font-weight: 400;
  font-family: RobotoRegular, sans-serif;
`
export const Roboto_num3_b14 = css`
  font-size: 14px;
  line-height: 18px;
  font-weight: 700;
  font-family: RobotoBold, sans-serif;
`

export const Roboto_num3_r14 = css`
  font-size: 14px;
  line-height: 18px;
  font-weight: 400;
  font-family: RobotoRegular, sans-serif;
`
export const Roboto_num4_b12 = css`
  font-size: 12px;
  line-height: 16px;
  font-weight: 700;
  font-family: RobotoBold, sans-serif;
`

export const Roboto_num4_r12 = css`
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  font-family: RobotoRegular, sans-serif;
`

export const Roboto_num5_b10 = css`
  font-size: 10px;
  line-height: 12px;
  font-weight: 700;
  font-family: RobotoBold, sans-serif;
`
export const Roboto_num5_r10 = css`
  font-size: 10px;
  line-height: 12px;
  font-weight: 400;
  font-family: RobotoRegular, sans-serif;
`
